/* mcbazel motion theme - scroll behaviour */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var small  = window.matchMedia('(max-width:860px)');

  /* the hero slot rotates: one product per visit, drawn from both sides of the catalogue.
     In Shopify this becomes a block list in the theme editor. */
  var picks = [].slice.call(document.querySelectorAll('.hero__pick'));
  if (picks.length) picks[Math.floor(Math.random() * picks.length)].classList.add('on');

  /* the ground warms as the mark comes down - one shift, not the reference's three,
     because the palette is paper/ink/amber and three would fight it */
  var TONE_FROM = [231, 233, 227], TONE_TO = [222, 219, 207];

  function tone(t){
    return 'rgb(' + TONE_FROM.map(function(c, k){
      return Math.round(c + (TONE_TO[k] - c) * t);
    }).join(',') + ')';
  }

  var ex = document.getElementById('ex'),
      stage = document.querySelector('.ex__stage'),
      core = document.getElementById('exCore'),
      prog = document.getElementById('exProg'),
      nEl = document.getElementById('exN'),
      parts = [].slice.call(document.querySelectorAll('.ex__part')),
      motes = [].slice.call(document.querySelectorAll('.ex__mote')),
      N = parts.length,
      ticking = false;

  function clamp(v){ return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ease(t){ return 1 - Math.pow(1 - t, 3); }

  /* flat mode: the whole diagram laid out as a list, no pinning. Phones and reduced motion. */
  function flat(){ return reduce || small.matches; }

  function settleAll(){
    if (!ex || !core) return;
    if (stage) stage.style.backgroundColor = tone(1);
    core.style.opacity = 1;
    core.style.transform = 'none';
    parts.forEach(function(el){
      el.style.opacity = 1;
      el.style.transform = 'translate(' + el.dataset.tx + 'vmin,' + el.dataset.ty + 'vmin)';
      el.style.setProperty('--lp', 1);
    });
    if (nEl) nEl.textContent = N;
  }

  function frame(){
    ticking = false;
    if (!ex || flat()) return;
    var r = ex.getBoundingClientRect();
    var p = clamp(-r.top / (ex.offsetHeight - window.innerHeight));
    if (prog) prog.style.width = (p * 100).toFixed(2) + '%';

    /* the mark arrives already landed, handed over by the traveller above. It shows only
       once the section has pinned, which is the same instant the traveller hides. */
    core.style.opacity = r.top <= 0 ? 1 : 0;
    var settle = ease(clamp(p / 0.18));
    core.style.transform = 'scale(' + (1 - 0.22 * settle).toFixed(3) + ')';
    if (stage) stage.style.backgroundColor = tone(settle);

    motes.forEach(function(el){
      var depth = parseFloat(el.style.getPropertyValue('--pd')) || 0;
      el.style.setProperty('--py', ((p - 0.5) * depth).toFixed(1) + 'px');
    });

    var landed = 0;
    parts.forEach(function(el, i){
      var t = ease(clamp((p - (0.05 + i * 0.09)) / 0.24));
      el.style.opacity = t;
      el.style.transform = 'translate(' + (el.dataset.tx * t) + 'vmin,' + (el.dataset.ty * t) + 'vmin)';
      el.style.setProperty('--lp', clamp((t - 0.55) / 0.45));
      if (t > 0.6) landed++;
    });
    if (nEl) nEl.textContent = landed;
  }

  /* One continuous fall: the mark enters from above as soon as you scroll, follows you down
     the hero, and arrives dead centre at exactly the moment the catalogue section pins - where
     the section's own core takes over at the same size and position. */
  var trav = document.querySelector('.drop'),
      hero = document.getElementById('top');

  function travel(){
    if (!trav || !hero) return;
    if (flat()){ trav.style.opacity = 0; return; }
    var H = Math.max(hero.offsetHeight, 1);
    var q = clamp(window.scrollY / H);
    var e = ease(q), rise = 1 - e;
    trav.style.opacity = window.scrollY >= H ? 0 : clamp((q - 0.03) / 0.14);
    trav.style.transform = 'translate(-50%,-50%) '
      + 'translate(' + (rise * window.innerWidth * -0.17).toFixed(1) + 'px,'
                     + (rise * window.innerHeight * -0.74).toFixed(1) + 'px) '
      + 'rotate(' + (-195 * rise).toFixed(1) + 'deg) '
      + 'scale(' + (0.55 + 0.45 * e).toFixed(3) + ')';
  }

  function onScroll(){
    if (!ticking){ ticking = true; requestAnimationFrame(function(){ frame(); travel(); }); }
  }

  function sync(){
    if (!ex || !core){ if (trav) trav.style.opacity = 0; return; }
    if (flat()){
      ex.classList.add('ex--flat');
      if (trav) trav.style.opacity = 0;
      core.style.opacity = 1;
      if (nEl) nEl.textContent = N;
    } else {
      ex.classList.remove('ex--flat');
      if (reduce) settleAll(); else { frame(); travel(); }
    }
  }

  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', function(){ sync(); onScroll(); });
  sync();

  /* ---- product thumbnails ----
     Clicking a thumbnail swaps the main image. srcset has to be cleared, otherwise the browser
     keeps choosing from the old candidate list and the picture never changes. */
  (function(){
    var main = document.querySelector('[data-product-main]'),
        thumbs = [].slice.call(document.querySelectorAll('[data-thumb]'));
    if (!main || !thumbs.length) return;

    thumbs.forEach(function(btn){
      btn.addEventListener('click', function(){
        var full = btn.getAttribute('data-full');
        if (!full) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = full;
        thumbs.forEach(function(t){ t.classList.toggle('is-active', t === btn); });
      });
    });
  })();

  /* ---- video carousels ----
     One per section, so several can sit on the same page. Buttons appear only when the track
     actually overflows, and scroll by one card at a time. */
  [].slice.call(document.querySelectorAll('[data-carousel]')).forEach(function(track){
    var rail = track.parentElement,
        prev = rail.querySelector('[data-carousel-prev]'),
        next = rail.querySelector('[data-carousel-next]');
    if (!prev || !next) return;

    function step(){
      var card = track.querySelector('.rep');
      return card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
    }
    function refresh(){
      var overflows = track.scrollWidth - track.clientWidth > 4;
      if (!overflows){ prev.hidden = true; next.hidden = true; return; }
      prev.hidden = track.scrollLeft < 8;
      next.hidden = track.scrollLeft > track.scrollWidth - track.clientWidth - 8;
    }
    prev.addEventListener('click', function(){ track.scrollBy({left: -step(), behavior: 'smooth'}); });
    next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior: 'smooth'}); });
    track.addEventListener('scroll', refresh, {passive: true});
    window.addEventListener('resize', refresh);
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(track);
    refresh();
  });

  /* ---- phone menu ----
     The desktop bar is hidden below 860px, so this is the only navigation on a phone.
     Opens from the burger, closes on the X, on the scrim, and on Escape; focus moves into
     the panel and returns to the burger afterwards, and the page behind is locked. */
  var navRoot = document.getElementById('MobileNav'),
      navOpen = document.getElementById('NavOpen'),
      navClose = document.getElementById('NavClose');

  function setNav(open){
    if (!navRoot || !navOpen) return;
    if (open){
      navRoot.hidden = false;
      requestAnimationFrame(function(){ navRoot.classList.add('open'); });
      document.body.style.overflow = 'hidden';
      if (navClose) navClose.focus();
    } else {
      navRoot.classList.remove('open');
      document.body.style.overflow = '';
      navOpen.focus();
      setTimeout(function(){
        if (!navRoot.classList.contains('open')) navRoot.hidden = true;
      }, 340);
    }
    navOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (navOpen) navOpen.addEventListener('click', function(){ setNav(true); });
  if (navRoot){
    navRoot.addEventListener('click', function(e){
      if (e.target.hasAttribute('data-nav-close') || e.target.id === 'NavClose') setNav(false);
      /* following a link should close it too, so returning via Back does not show it open */
      if (e.target.tagName === 'A') setNav(false);
    });
  }
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && navRoot && navRoot.classList.contains('open')) setNav(false);
  });
  /* rotating to landscape can cross the breakpoint and leave a stranded panel */
  small.addEventListener('change', function(e){
    if (!e.matches && navRoot && navRoot.classList.contains('open')) setNav(false);
  });

  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target); }
    });
  }, {rootMargin:'0px 0px -12% 0px'});
  [].slice.call(document.querySelectorAll('.card,.rep')).forEach(function(el, i){
    el.style.transitionDelay = ((i % 4) * 60) + 'ms';
    io.observe(el);
  });
})();

/* Partner videos: press the still and the player replaces it in place. Nothing is requested
   from YouTube until that press, and starting one stops whichever was already running. */
(function () {
  var open = null;

  function stop(btn) {
    if (!btn) { return; }
    var f = btn.querySelector('iframe');
    if (f) { f.parentNode.removeChild(f); }
    btn.classList.remove('is-live');
    btn.setAttribute('aria-pressed', 'false');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-yt]');
    if (!btn) { return; }
    if (btn.classList.contains('is-live')) { return; }

    stop(open);
    var id = btn.getAttribute('data-yt');
    var f = document.createElement('iframe');
    /* www.youtube.com, not youtube-nocookie.com. The nocookie host withholds the cookies
       YouTube uses to tell a person from a script, so its bot check ("Sign in to confirm
       you're not a bot") fires far more often - especially on VPNs and shared networks.
       Nothing is requested from either host until this click, so the privacy that matters
       is unchanged. */
    f.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) +
            '?autoplay=1&rel=0&playsinline=1&origin=' + encodeURIComponent(location.origin);
    f.title = btn.getAttribute('aria-label') || 'Video';
    f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    f.setAttribute('allowfullscreen', '');
    btn.appendChild(f);
    btn.classList.add('is-live');
    btn.setAttribute('aria-pressed', 'true');
    open = btn;
  });
}());

/* Footer mark: play once, when it is actually scrolled to. */
(function () {
  var mark = document.querySelector('.ft__mark--anim');
  if (!mark) { return; }
  if (!('IntersectionObserver' in window)) { mark.classList.add('play'); return; }
  /* Play only once the mark is nearly all on screen. At a low threshold it starts while the
     footer is still entering, so most of the motion happens below the fold and you catch the
     tail of it. The height test is the escape for a viewport too short to ever show 90%. */
  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var tall = en.boundingClientRect.height > window.innerHeight * 0.8;
      if (!en.isIntersecting) { return; }
      if (en.intersectionRatio < 0.9 && !tall) { return; }
      en.target.classList.add('play');
      seen.unobserve(en.target);
    });
  }, { threshold: [0.25, 0.9] });
  seen.observe(mark);
}());
